import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import TagStatus from "components/Pages/Finance/_cmpt/TagStatus";
import Countdown from "components/Pages/Finance/_cmpt/Countdown";
import Currency from "components/Pages/Finance/_cmpt/Currency";
import TagCustom from "components/Pages/Finance/_cmpt/TagCustom";
import TagHot from "components/Pages/Finance/_cmpt/TagHot";
import Apy from "components/Pages/Finance/_cmpt/Apy";
import BtnSubscribe from "components/Pages/Finance/_cmpt/BtnSubscribe";
import useCountdown from "components/Pages/Finance/_hook/useCountdown";
import useProductName from "components/Pages/Finance/_hook/useProductName";
import useGetProductById from "@/components/Pages/Finance/_hook/useGetProductById";

import styles from "./index.module.less";
import stylesCard from "components/Pages/Finance/Styles/card.module.less";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data }) => {
  const t = useTranslation();
  const { finance } = useStore();

  const [product, setProduct] = useState(data);
  useEffect(() => {
    setProduct(data);
  }, [data]);

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    const convertData = {
      tagStatus: product.financeProductStatus,
      //币种，譬如：usdt
      currency: product.currency,
      //可选，最小认购，
      minBuy: (() => {
        if (!product.singleMin) return;
        return product.singleMin + " " + product.currency.toUpperCase();
      })(),
      tagHot: product.systemTag === "HOT",
      //系统标签
      // tagCustom: (() => {
      //   if (!product.customTags || !product.customTags.length) return [];
      //   const ary = [];
      //   product.customTags.map((obj) => ary.push(obj.name));
      //   return ary;
      // })(),
      //期限，譬如：365天，只有 【理财宝-活期】是活期的，其他的都有期限
      duration: (() => {
        if (product.productType === "DEMAND_SAVING") return t("finance.flexible");
        return product.duration + "D";
      })(),
    };

    return convertData;
  }, [product]);
  const destTimestamp = useCountdown(product);
  const productName = useProductName(product);

  const onFinancialProductsChange = (newFinancialProducts) => {
    for (let i in newFinancialProducts) {
      if (newFinancialProducts[i].id == product.id) setProduct(newFinancialProducts[i]);
    }
  };
  const btnData = useMemo(() => {
    return {
      productId: product.id,
      financialProducts: [product],
      callback: onFinancialProductsChange,
    };
  }, [product]);
  const countdownCallbackFun = useGetProductById(({ err, data }) => {
    if (err) return;
    onFinancialProductsChange([data]);
  });
  const countdownCallback = () => countdownCallbackFun(product);

  return (
    <div className={cx(stylesCard.main, styles.main)}>
      <div className={stylesCard.nav}>
        <div>
          <TagStatus data={selfData.tagStatus} />
        </div>
        <div>
          <Countdown key={product.id + "-" + destTimestamp} data={destTimestamp} isHideExpired callback={countdownCallback} />
        </div>
      </div>
      <div className={stylesCard.currencyCon}>
        <div>
          <Currency data={selfData.currency} className={stylesCard.currency} />
        </div>
        <div>
          {!!selfData.minBuy && (
            <div className={stylesCard.minBuy}>
              <div>{selfData.minBuy}</div>
              <span>{t("finance.minStart")}</span>
            </div>
          )}
        </div>
      </div>
      <div className={stylesCard.productCon}>
        <b>{productName}</b>
        {selfData.tagHot && <TagHot />}
      </div>
      <div className={stylesCard.detailCon}>
        <div>
          <div>
            <Apy className={stylesCard.apy} data={product} />
          </div>
          <span>{t("finance.apy")}</span>
        </div>
        <span></span>
        <div>
          <div>
            <b>{selfData.duration}</b>
          </div>
          <span>{t("finance.duration")}</span>
        </div>
      </div>

      <div className={stylesCard.btnCon}>
        <BtnSubscribe data={btnData} />
      </div>
    </div>
  );
});
